export const USE_BEARER = true;
export const ACCESS_TOKEN_KEY = 'meridian_access_token2';
export const REFRESH_TOKEN_KEY = 'meridian_refresh_token2';
export const REFRESH_TIMESTAMP_KEY = 'meridian_timestamp_key2';
export const DEFAULT_REFRESH_INTERVAL_MS = 1 * 60 * 1000;
